import axios from 'axios'
Vue.prototype.$http = axios
import AESUtil from './static/js/AESUtil.js'
import router from './src/router'
import index from './static/sotre'
import $ from 'jquery'

import Vue from 'vue';
import {
  Dialog,
  Toast
} from 'vant';
import {
  $http
} from 'vux/src/plugins/ajax'

// 全局注册
Vue.use(Dialog);

// import qs from 'qs'
// import NProgress from 'nprogress'
axios.interceptors.request.use(config => {
  //  NProgress.start()
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => response, error => Promise.resolve(error.response))

function checkStatus(response) {
  //  NProgress.done()
  // console.log(response)
  if (response.status === 200 || response.status === 304) {
    if (!response.data.body) { //主要是判断登录的接口返回的信息，登录接口返回的信息没有errorInfo
      if (response.data.errorId == '-1') {
        // Toast('访问失败,请稍后再试！')
        return
      }
      if (response.data.result) {
        if (response.data.result.errorInfo) {
          if (response.data.result.errorInfo == '500: 请先登录') {
            Dialog.alert({
              message: '授权失效，重新获取授权！',
            }).then(() => {
              // 确定
              router.push({
                path: '/login?token=1'
              })
            });
            console.log('500错误')
          }
        }
      }
    }
    return response
  }
  return {
    data: {
      code: -404,
      message: response.statusText,
      data: response.statusText
    }
  }
}

function refresh() {
  let params = {
    JSON: {
      methodUrl: "/jslogin/refreshtoken",
      methodType: "POST",
      body: {
        accesstoken: sessionStorage.getItem('accesstoken'),
        refreshtoken: sessionStorage.getItem('refreshtoken')
      },
      query: {},
      busCode: "11RC010102",
    },
  };
  console.log(params)
  let param = {
    JSON: JSON.stringify(params.JSON)
  }
  var url = index.state.status.JBUrl;
  axios({
    method: 'post',
    url,
    params: param,
    header: {
      'Content-Type': 'application/json' //如果写成contentType会报错
    }
  }).then((res) => {
    console.log(res.data.result, '=====')
    if (sessionStorage.getItem('accesstoken') == res.data.result.accesstoken && sessionStorage.getItem(
        'refreshtoken') == res.data.result.refreshtoken) {
      console.log('相同不向sessionStroage里面存放数据')
    } else {
      sessionStorage.setItem('accesstoken', res.data.result.accesstoken)
      sessionStorage.setItem('refreshtoken', res.data.result.refreshtoken)
      sessionStorage.setItem("expiresin", res.data.result.expiresin);
    }
  }).then(err => {
    // console.log(err)
  })
}

function checkCode(res) {
  // if (res.data.code !== 200) {
    //      alert(res.data.message)
  // }
  return res
}
var beseUrl = 'http://weixin.njrsrc.cn/CMP/BaseServer'
// var beseUrl = 'http://ybj.cross.echosite.cn/CMP/baseServer'
// var beseUrl = 'http://ybj.cross.echosite.cn/CMP/baseServer'
// var beseUrl = 'http://weixin.njrsrc.cn/CMP/BaseServer'
// var beseUrl = 'http://192.168.19.189:8085/CMP/BaseServer'
// var beseUrl =  'http://127.0.0.1:8085/CMP/BaseServer'

// var beseUrl =  'http://markye.qicp.vip/CMP/baseServer'

// var beseUrl =  'http://192.168.19.181/CMP/baseServer'

function post1(url, params) {
  let param = {
    JSON: AESUtil.Encrypt(JSON.stringify(params.JSON))
  }
  //console.log(param)
  return axios({
    method: 'post',
    // baseURL:'/api',
    // url:url,
    url,
    //params: param,
    params,
    header: {
      'Content-Type': 'application/json' //如果写成contentType会报错
    }
  }).then((res) => {
    console.log(res, '刷新登录')
  }).then(checkCode)
}

export default {
  postTB(url, params) {
    return axios({
      url,
      method: 'POST',
      data: params,
      header: {
        'Content-Type': 'application/json' //如果写成contentType会报错
      }
    }).then(checkStatus).then(checkCode)
  },
  post(url, params,data) {

    let param = {
      JSON: AESUtil.Encrypt(JSON.stringify(params.JSON))
    }
    //console.log(param)
    return axios({
      method: 'post',
      // baseURL:'/api',
      // url:url,
      url,
      //params: param,
      params,
      data,
      header: {
        'Content-Type': 'application/json', //如果写成contentType会报错
      }
      // data: qs.stringify(data),
      // timeout: 30000
      // headers: {
      //   'X-Requested-With': 'XMLHttpRequest',
      //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      // }
    }).then(checkStatus).then(checkCode)
  },
  get(url, params) {
    return axios({
      method: 'get',
      // baseURL:'/api',
      url,
      params,
      // timeout: 30000
      // headers: {
      //   'X-Requested-With': 'XMLHttpRequest'
      // }
    }).then(checkStatus).then(checkCode)
  },
  get1(url, params) {
    return axios({
      method: 'get',
      url: 'http://weixin.njrsrc.cn/wx/info',
      // url:'http://192.168.19.189:8085/wx/info',
      // url:'http://127.0.0.1:8085/wx/info',
      // url:'http://192.168.19.181:8085/wx/info',
      params,
      // timeout: 30000
    }).then(checkStatus).then(checkCode)
  }
}



//////////////////
// WEBPACK FOOTER
// ./http.js
// module id = null
// module chunks = 